import { useCookie } from '#imports'

import { DISABLE_TRACKERS_COOKIE_NAME } from '../constants'

/**
 * Used by E2E tests to forcefully enable/disable tracking
 */
export function useDisableTrackers() {
  const cookies = useCookie(DISABLE_TRACKERS_COOKIE_NAME)

  return cookies?.value === 'true'
}
